import util from 'preact-util';

/**
 * Sponsor logo views/clicks from the hero bar. Posted straight to the public
 * POST /api/articles/:id/sponsor-events — NOT through appState.addUsageLog,
 * whose /api/usageLogs delivery requires a login and the frontpage is mostly
 * anonymous traffic. Fire-and-forget: a failed post is simply dropped.
 */
export async function postSponsorEvents({ articleId, events, fetchApi = util.fetchApi }) {
    if (!(articleId > 0) || !Array.isArray(events) || events.length === 0) {
        return undefined;
    }
    try {
        await fetchApi(`/api/articles/${articleId}/sponsor-events`, { method: 'POST' }, { events });
    } catch (err) {
        // Tracking must never break the page.
    }
    return undefined;
}

export default { postSponsorEvents };
